import React, { Component } from 'react'
import { translate } from '../../utils/useful'
import EmailFile from './EmailFile'
// import EmailFrame from './EmailFrame'


export default class EmailToolbar extends Component {


    toggleSelectMode = () => {
        this.props.toggleSelectMode()
    }

    SelectAllMail = () => {
        if (this.props.SelectAllMail) {
            this.props.SelectAllMail()
        }
    }

    render() {
        return (
            <>

                <div className=''>
                    {this.props.selectMode == true ?
                        <div className='flexc'>
                            <button className='flexcc pld-2 prd-3 py-1 br-5 dark-blur-hover mrd-2' onClick={() => { this.SelectAllMail() }} style={{ height: '27px' }}>
                                <img className='flexcc mrd-1' width={20} src='/assets/icons/email/checklist-white-all.svg' />
                                <p className='font-size-14' style={{ color: '#fff' }}>{translate('Select All')}</p>
                            </button>
                            <button className='flexcc pld-2 prd-3 py-1 br-5 dark-blur-hover mrd-2' style={{ height: '27px' }}>
                                <img className='flexcc mrd-1' width={20} src='/assets/icons/email/trash-white.svg' />
                                <p className='font-size-14 ' style={{ color: '#fff' }}>{translate('Delete')}</p>
                            </button>
                            <button className='flexcc pld-2 prd-3 py-1 br-5 dark-blur-hover mrd-2' style={{ height: '27px' }}>
                                <img className='flexcc mrd-1' width={20} src='/assets/icons/email/star-white-empty.svg' />
                                <p className='font-size-14 ' style={{ color: '#fff' }}>{translate('Starred')}</p>
                            </button>
                            <button className='flexcc px-3 py-1 br-5 dark-blur-bg mrd-2' style={{ height: '27px' }} onClick={() => this.toggleSelectMode()}>
                                <p className='font-size-14 ' style={{ color: '#fff' }}>{translate('Cancel')}</p>
                            </button>
                        </div>
                        :
                        <div className='flexc'>
                            <EmailFile width={this.props.width} colors={this.props.colors} functionsHandler={this.props.functionsHandler} />
                            <button className='mrd-2 flexcc dark-blur-hover px-2 py-1 br-5' style={{ height: '27px' }} onClick={() => this.props.functionsHandler(null, 'fetchData')}>
                                <div className='flexcc mrd-1'>
                                    <img className={'flexcc' + (this.props.invert ? 'invert' : '')} width={18} src="/assets/icons/email/refresh-white.svg" />
                                </div>
                                <p className='font-size-14 ' style={{ color: '#fff' }}>{translate('Refresh')}</p>
                            </button>
                            <button className='mrd-2 flexcc dark-blur-hover px-2 py-1 br-5' style={{ height: '27px' }} onClick={() => this.props.toggleSelectMode()}>
                                <div className='flexcc mrd-1'>
                                    <img className={'flexcc' + (this.props.invert ? 'invert' : '')} width={18} src="/assets/icons/email/checklist-white.svg" />
                                </div>
                                <p className='font-size-14 ' style={{ color: '#fff' }}>{translate('Select')}</p>
                            </button>
                        </div>
                    }
                </div>
            </>
        )
    }
}
